export enum BUSINESS_TRIGGER_CTA {
    DEFAULT = 'default',
    CONTACT = 'contact',
    PURCHASE = 'purchase',
    COLLABORATING = 'collaborating',
    INVITE = 'invitation',
    AGGRESSIVE = 'aggressive',
    /** @deprecated - Use "DEFAULT" */
    MIGRATION = 'migration',
    SAVE_EXPERT = 'save_expert',
    REQUEST_QUOTE = 'request_a_quote',
    NO_RESULT_PAGE_CHAT = 'no_result_page_chat',
    NO_RESULT_PAGE_BRIEF = 'no_result_page_brief',
    PROJECT_PARTNERS_FIP_BANNER = 'project_manage_fip_banner',
    PAYMENT = 'payment',
    HOURLY_ACCEPT = 'hourly_accept',
    LOYALTY = 'loyalty',
    MONEY_BACK = 'money_back',
    UPGRADE_TO_PRO = 'upgrade_to_pro',
}

export interface CtaData {
    type: BUSINESS_TRIGGER_CTA;
    source?: string;
    data?: Record<string, unknown>;
}
